import { render, staticRenderFns } from "./shift-move-modal.vue?vue&type=template&id=8ea8f536&scoped=true&"
import script from "./shift-move-modal.vue?vue&type=script&lang=js&"
export * from "./shift-move-modal.vue?vue&type=script&lang=js&"
import style0 from "./shift-move-modal.vue?vue&type=style&index=0&id=8ea8f536&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea8f536",
  null
  
)

export default component.exports